import React, {
    Component,
    PropTypes
} from 'react';
import OptionsDropDown from '../shared/components/options-drop-down';
import SapEnvironment from '../shared/models/sap-environment';

const getDefaultValue = sapEnvironments =>
    sapEnvironments.find(environment => environment.defaultVal);

class SapEnvironments extends Component {

    state = {
        selectedValue: getDefaultValue(this.props.sapEnvironments).name
    };

    handleSapEnvironmentChange = newValue => {

        this.props.onSapEnvironmentChange(newValue);

        this.setState({
            selectedValue: newValue
        });

    };

    render = () =>

        <OptionsDropDown
            className='sap-environments-dropdown'
            isPlaceholderTranslated={true}
            onChange={this.handleSapEnvironmentChange}
            optionDisplayAttributes={['name']}
            optionKey='name'
            options={this.props.sapEnvironments}
            placeholder=''
            selectedValue={this.state.selectedValue}
        />;

}

SapEnvironments.displayName = 'SapEnvironments';
SapEnvironments.propTypes = {
    onSapEnvironmentChange: PropTypes.func.isRequired,
    sapEnvironments: PropTypes.arrayOf(PropTypes.instanceOf(SapEnvironment)).isRequired
};

export default SapEnvironments;



// WEBPACK FOOTER //
// ./src/app/sap-environments.js